import styles from '../BrightcovePlayer.module.scss';
import { PlayButtonSize } from './enums';
export interface BrightcovePlayerProps {
  /**
   * @description In addition to playerId and videoId
   * we need `accountId` which  is set using config service
   */
  accountId?: string;
  playerId?: string;
  videoId: string;
  containerClassName?: string;
  iframeTitle?: string;
  playerWidth?: number | string;
  playerHeight?: number | string;

  /**
   * @description setting this prop to `true` will override the playerHeight, playerWidth
   */
  isPlayerResponsive?: boolean;
  poster?: string;

  // video controls
  autoplay?: boolean;
  muted?: boolean;
  loop?: boolean;

  playerRef?: React.MutableRefObject<BrightcovePlayerRef>;
  playerOnReadyHandler?: (playerRef: React.MutableRefObject<BrightcovePlayerRef>) => void;
  playButtonSize?: PlayButtonSize;
  playOnButtonClick?: boolean;
  /**
   * @description setting this prop to `true` will add duration tag in player.
   */
  showDuration?: boolean;
}

export interface BrightcovePlayerRef {
  on: (eventType: string, callback: () => void) => void;
  bigPlayButton?: Record<string, HTMLButtonElement>;
  play?: () => void;
  pause?: () => void;
  ready?: (cb: () => void) => void;
  controls?: (showControls: boolean) => void;
  playbackRates?: (playbackRates: Array<number>) => void;
  mediainfo: {
    duration: number;
  };
}

export interface BrightcovePlayerAttributes {
  options: {
    autoplay: boolean;
    muted: boolean;
    loop: boolean;
    fluid: boolean;
    height: number;
    width: number;
    poster: string;
    responsive: boolean;
  };
  embedOptions: {
    responsive: boolean;
  };
  accountId: string;
  playerId: string;
  videoId: string;
  onSuccess: (success: { ref: BrightcovePlayerRef }) => void;
}
export type ChangeStyleFnPropType = {
  element: HTMLButtonElement;
  buttonSize: string;
  margin: string;
  fontSize: string;
};

export const buttonSizeMapping = {
  [PlayButtonSize.LARGE]: {
    buttonSize: styles.largePlaybuttonSize,
    margin: styles.largePlaybuttonMargin,
    fontSize: styles.largePlaybuttonFontSize,
  },
  [PlayButtonSize.MEDIUM]: {
    buttonSize: styles.mediumPlaybuttonSize,
    margin: styles.mediumPlaybuttonMargin,
    fontSize: styles.mediumPlaybuttonFontSize,
  },
  [PlayButtonSize.SMALL]: {
    buttonSize: styles.smallPlaybuttonSize,
    margin: `-${styles.smallPlaybuttonFontSize}`,
    fontSize: styles.smallPlaybuttonFontSize,
  },
};
